import { render, staticRenderFns } from "./PortfolioInterestedItem.vue?vue&type=template&id=577ee41c&"
import script from "./PortfolioInterestedItem.vue?vue&type=script&lang=js&"
export * from "./PortfolioInterestedItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports